import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Priority } from '../model/Priority';
import { PrioritySerializer } from '../model/serializer/priority-serializer';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class CommonService extends ApiService<Priority> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job/priority',
      new PrioritySerializer());
  }
}
